/**
 * Creates the UUID used to make message submissions idempotent.
 *
 * Browsers released before `crypto.randomUUID()` still expose
 * `crypto.getRandomValues()`, so retain a UUID-v4 fallback for those clients.
 */
export function createClientId() {
    const cryptoApi = typeof window === 'undefined' ? undefined : window.crypto;
    if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
        return cryptoApi.randomUUID();
    }
    if (!cryptoApi || typeof cryptoApi.getRandomValues !== 'function') {
        throw new Error('Your browser is too old to send messages securely. Please update it.');
    }
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
    const value = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
}
//# sourceMappingURL=client-id.js.map